import React from "react";
import css from "classnames";

export enum ButtonType {
  Primary,
  Secondary,
  Transparent
}

interface Props {
  onClick?: (e?) => any;
  className?: string;
  children?: any;
  type?: ButtonType;
}

const styles = require("./styles.module.scss")

export const CallToAction = ({className, type = ButtonType.Primary, children, onClick}: Props) => {

  const handleClick = () => {
    if(onClick) {
      onClick();
    }
  }
  return (
    <button
      className={css(styles.callToAction, className && className, type === ButtonType.Secondary && styles.secondary, type === ButtonType.Transparent && styles.transparent)}
      onClick={handleClick}
    >
      {children}
    </button>
  )
}
